import React, {
	useEffect,
	useState,
	useContext
} from "react";

import { firestore } from "../common/firebase";
import {
  collection,
  query,
  where,
  orderBy,
  limit as fsLimit,
  onSnapshot,
  doc,
} from "firebase/firestore";



// *** System API ***
/*
system = uid => this.db.doc(`systems/${uid}`);
systems = () => this.db.collection('systems');
usersystems = userid => this.systems().where( "userId", "==", `${userid}`);

gateway = uid => this.db.doc(`gateways/${uid}`);
gatewayconfig = uid => this.db.doc(`gateways/${uid}/config/network`);
gatewaystate = uid => this.db.doc(`gateways/${uid}/config/state`);

gateways = () => this.db.collection('gateways');
systemgateways = sysid => this.gateways().where("system_id", "==", `${sysid}`);

scene = uid => this.db.doc( `scenes/${uid}` );
scenes = () =>this.db.collection('scenes');
systemscenes = sysid =>this.scenes().where("system_id", "==", `${sysid}`);
*/

function useSystems(uid, limit) {
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(true)
	const [systems, setSystems] = useState([])
	
	useEffect(
		() => {
			if (!uid) {
				setLoading(false);
				return;
			}
			const systemsRef = collection(firestore, 'systems');
			const q = query(
				systemsRef,
				where("userId", "==", uid),
				orderBy('createdAt', 'desc'),
				fsLimit(limit || 100)
			);
			const unsubscribe = onSnapshot(
				q,
				(snapshot) => {
					const sys = [];
					snapshot.forEach((d) =>
						sys.push({ ...d.data(), uid: d.id })
					);
					setSystems(sys.reverse());
					setLoading(false);
				},
				(err) => {
					setError(err);
				}
			);
			return () => unsubscribe();
		},
		[uid, limit]
	)

	return {
		error,
		loading,
		systems,
	};
}

function useGuestSystems(uid, limit){
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(true)
	const [guestSystems, setGuestSystems] = useState([])
	
	useEffect(
		() => {
			if (!uid) {
				setLoading(false);
				return;
			}
			const systemsRef = collection(firestore, 'systems');
			const q = query(
				systemsRef,
				where("guests", "array-contains", uid),
				fsLimit(limit || 100)
			);
			const unsubscribe = onSnapshot(
				q,
				(snapshot) => {
					const sys = [];
					snapshot.forEach((d) =>
						sys.push({ ...d.data(), uid: d.id })
					);
					setGuestSystems(sys.reverse());
					setLoading(false);
				},
				(err) => {
					setError(err);
				}
			);
			return () => unsubscribe();
		},
		[uid, limit]
	)

	return {
		error,
		loading,
		guestSystems,
	}; 

}

function useScenes(uid, limit) {
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(true)
	const [scenes, setScenes] = useState([])
	
	useEffect(
		() => {
			if (!uid) {
				setLoading(false);
				return;
			}
			const scenesRef = collection(firestore, 'scenes');
			const constraints = [
				where("system_id", "==", uid),
				orderBy('createdAt', 'desc'),
			];
			if (limit && limit > 0) {
				constraints.push(fsLimit(limit));
			}
			const q = query(scenesRef, ...constraints);
			const unsubscribe = onSnapshot(
				q,
				(snapshot) => {
					const sys = [];
					snapshot.forEach((d) =>
						sys.push({ ...d.data(), uid: d.id })
					);
					setScenes(sys.reverse());
					setLoading(false);
				},
				(err) => {
					setError(err);
				}
			);
			return () => unsubscribe();
		},
		[uid, limit]
	)

	return {
		error,
		loading,
		scenes,
	};
}

function useCycles(uid, limit) {
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(true)
	const [cycles, setCycles] = useState([])
	
	useEffect(
		() => {
			if (!uid) {
				setLoading(false);
				return;
			}
			const cyclesRef = collection(firestore, 'cycles');
			const q = query(
				cyclesRef,
				where("system_id", "==", uid),
				orderBy('createdAt', 'desc'),
				fsLimit(limit || 100)
			);
			const unsubscribe = onSnapshot(
				q,
				(snapshot) => {
					const sys = [];
					snapshot.forEach((d) =>
						sys.push({ ...d.data(), uid: d.id })
					);
					setCycles(sys.reverse());
					setLoading(false);
				},
				(err) => {
					setError(err);
				}
				)
			return () => unsubscribe()
		},
		[uid , limit]
	)

	return {
		error,
		loading,
		cycles,
	};
}


function useGateways(uid, limit) {
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(true)
	const [gateways, setGateways] = useState([])
	
	useEffect(
		() => {
			if (!uid) {
				setLoading(false);
				return;
			}
			const gatewaysRef = collection(firestore, 'gateways');
			const q = query(
				gatewaysRef,
				where("system_id", "==", uid),
				orderBy('createdAt', 'desc'),
				fsLimit(limit || 100)
			);
			const unsubscribe = onSnapshot(
				q,
				(snapshot) => {
					const sys = [];
					snapshot.forEach((d) =>
						sys.push({ ...d.data(), uid: d.id })
					);
					setGateways(sys.reverse());
					setLoading(false);
				},
				(err) => {
					setError(err);
				}
			);
			return () => unsubscribe();
		},
		[uid, limit]
	)

	return {
		error,
		loading,
		gateways,
	};
}

function useSchedules(uid, limit) {
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(true)
	const [schedules, setSchedules] = useState([])
	
	useEffect(
		() => {
			if (!uid) {
				setLoading(false);
				return;
			}
			const schedulesRef = collection(firestore, 'schedules');
			const q = query(
				schedulesRef,
				where("system", "==", uid),
				orderBy('performAt', 'asc'),
				fsLimit(limit || 100)
			);
			const unsubscribe = onSnapshot(
				q,
				(snapshot) => {
					const sys = [];
					snapshot.forEach((d) =>
						sys.push({ ...d.data(), uid: d.id })
					);
					setSchedules(sys);
					setLoading(false);
				},
				(err) => {
					setError(err);
				}
			);
			return () => unsubscribe();
		},
		[uid, limit]
	)

	return {
		error,
		loading,
		schedules,
	};
}


const CurrentSystemContext = React.createContext();

const CurrentSystemProvider = ({ children }) => {
	const [ error, setError] = useState(false);
	const [ currentSystem,  setCurrentSystem ] = useState(undefined);
	const [loading, setLoading] = useState(true);
  	const [ currentSystemUID, setCurrentSystemUID ] = useState("");

  useEffect(
	() =>{
	if( currentSystemUID !== ""){
		const systemRef = doc(firestore, 'systems', currentSystemUID);
		const unsubscribe = onSnapshot(
			systemRef,
			(docSnap) => {
				setLoading(false)
				setCurrentSystem({ ...docSnap.data(), uid: docSnap.id })
			},
			(err) => {
				setError(err)
			}
		);
		return () => unsubscribe();
	} else {
		setCurrentSystem(undefined);
	}
},
[ currentSystemUID]);

  return (
	<CurrentSystemContext.Provider value={ { error, loading, currentSystem, setCurrentSystemUID } } >
	  {children}
	</CurrentSystemContext.Provider>
  );
};
// useAuth Hook!
const useCurrentSystem = () => {
  const { error, loading, currentSystem, setCurrentSystemUID } = useContext(CurrentSystemContext);
  return { error, loading, currentSystem, setCurrentSystemUID } ;
}

export { CurrentSystemProvider, CurrentSystemContext, useSystems,  useGuestSystems, useScenes, useCycles, useGateways, useCurrentSystem, useSchedules };



